import { state, logout } from './app';

export const api = {
  base: '/api',
  async request(method: string, path: string, body?: any) {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (state.token) headers['Authorization'] = 'Bearer ' + state.token;
    const opts: RequestInit = { method, headers };
    if (body) opts.body = JSON.stringify(body);
    const res = await fetch(this.base + path, opts);
    const data = await res.json();
    if (res.status === 401) { logout(); throw new Error('Session expired'); }
    if (!res.ok) throw new Error(data.error || 'Request failed');
    return data;
  },
  get(path: string) { return this.request('GET', path); },
  post(path: string, body?: any) { return this.request('POST', path, body); },
  put(path: string, body?: any) { return this.request('PUT', path, body); },
  del(path: string) { return this.request('DELETE', path); },
};
